<template lang="html">
  <div class="projectBasicContainer">
    <h1 v-if="newEmployee">新增員工</h1>
    <h1 v-else>編輯員工</h1>
    <div class="subtitle"><span>*</span> 為必填</div>
    <div class="tableContainer">
      <div class="fourColumn">
        <div class="title required">姓名</div>
        <Input v-model="employee.name" class="inputItemStyle" type="text" />
        <div class="title required">工號</div>
        <Input v-model="employee.jobNumber" class="inputItemStyle" type="text" />
        <div class="title">處</div>
        <Input v-model="employee.division" class="inputItemStyle" type="text" />
        <div class="title required">部門</div>
        <Input v-model="employee.department" class="inputItemStyle" type="text" />
        <div class="title">課</div>
        <Input v-model="employee.section" class="inputItemStyle" type="text" />
        <div class="title">E-mail</div>
        <Input v-model="employee.email" class="inputItemStyle" type="text" />
        <div class="title required">電話</div>
        <Input v-model="employee.phone" class="inputItemStyle" type="text" />
        <div class="title required">權限</div>
        <div class="authorize-box">
          <i-switch size="large" v-model="employee.authorize">
            <template #open>
              <span>開啟</span>
            </template>
            <template #close>
              <span>關閉</span>
            </template>
          </i-switch>
          <!-- <i-switch size="large" v-model="employee.authorize">
            <span slot="open">開</span>
            <span slot="close">關</span>
          </i-switch> -->
        </div>
        <div class="title required">廠區</div>
        <Input v-model="employee.factoryArea" class="inputItemStyle" type="text" />
        <div class="title">時段設定(選填)</div>
        <div class="inputItemStyle">
          <Select v-model="employee.startTime1" class="inputTime" placeholder="請選擇">>
            <Option :value="-1">不選擇</Option>
            <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <span>~</span>
          <Select v-model="employee.endTime1" class="inputTime" placeholder="請選擇">>
            <Option :value="-1">不選擇</Option>
            <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <Icon type="ios-close" size="24" @click="clearTime1" />
        </div>
        <div class="title">支付限制（金額）</div>
        <Input v-model="employee.payLimit" class="inputItemStyle" type="text" :disabled="!employee.isPayLimit">
        <i-switch @on-change="switchPayLimit" slot="prepend" v-model="employee.isPayLimit" />
        </Input>
        <div class="title">時段設定(選填)</div>
        <div class="inputItemStyle">
          <template v-if="employee.startTime1 !== null && employee.endTime1 !== null">
            <Select v-model="employee.startTime2" class="inputTime" placeholder="請選擇">
              <Option :value="-1">不選擇</Option>
              <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
            <span>~</span>
            <Select v-model="employee.endTime2" class="inputTime" placeholder="請選擇">
              <Option :value="-1">不選擇</Option>
              <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
            <Icon type="ios-close" size="24" @click="clearTime2" />
          </template>
        </div>
        <div class="title">搭乘限制（次數）</div>
        <Input v-model="employee.takingLimit" class="inputItemStyle" type="text" :disabled="!employee.isTakingLimit">
        <i-switch @on-change="switchTakingLimit" slot="prepend" v-model="employee.isTakingLimit" />
        </Input>
        <div class="title">時段設定(選填)</div>
        <div class="inputItemStyle">
          <template v-if="employee.startTime2 !== null && employee.endTime2 !== null">
            <Select v-model="employee.startTime3" class="inputTime" placeholder="請選擇">
              <Option :value="-1">不選擇</Option>
              <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
            <span>~</span>
            <Select v-model="employee.endTime3" class="inputTime" placeholder="請選擇">
              <Option :value="-1">不選擇</Option>
              <Option v-for="(item, index) in periodTimeArr" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
            <Icon type="ios-close" size="24" @click="clearTime3" />
          </template>
        </div>
        <div class="title required">付款密碼</div>
        <Input v-model="employee.payPassword" :disabled="!newEmployee" class="inputItemStyle" type="text" />
        <div class="title">備註</div>
        <Input v-model="employee.note" class="inputItemStyle" type="text" />
      </div>
    </div>
    <div class="btnContainer">
      <Button type="success" @click="submit">儲存</Button>
      <Button v-if="newEmployee" to="employeelist">取消</Button>
      <Button v-else @click="backToEmployeeInfo">取消</Button>
    </div>
  </div>
</template>

<script>
import { periodTimeArr } from "@/config.js";
import { endPoint, loginResponse } from "@/utilities/api";
import { getAllCookies } from "@/utilities/cookie";
import { formatHour } from "@/utilities/common";
import API from "../asset/js/API";
import moment from "moment";
export default {
  created() {
    const { info, id } = this.$route.params;
    if (info) {
      this.newEmployee = false;
      this.setData(info, id);
    }
  },
  data() {
    return {
      newEmployee: true,
      required: {
        name: "姓名",
        department: "單位部門",
        phone: "電話",
        factoryArea: "廠區",
        jobNumber: "工號",
        payPassword: "付款密碼",
        authorize: "權限"
      },
      employee: {
        name: null,
        jobNumber: null,
        department: null,
        email: null,
        phone: null,
        authorize: false,
        factoryArea: null,
        startTime1: null,
        endTime1: null,
        startTime2: null,
        endTime2: null,
        startTime3: null,
        endTime3: null,
        isPayLimit: false,
        isTakingLimit: false,
        payLimit: null,
        takingLimit: null,
        payPassword: null,
        note: null,
        division: null,
        section: null
      },
      periodTimeArr: periodTimeArr
    };
  },
  methods: {
    switchTakingLimit($event) {
      this.employee.isTakingLimit = $event;
      if (!$event) this.employee.takingLimit = null;
    },
    switchPayLimit($event) {
      console.log($event);
      this.employee.isPayLimit = $event;
      if (!$event) this.employee.payLimit = null;
    },
    submit() {
      // 判斷時間 function
      const allFilled = this.validateRequired();
      if (allFilled) {
        this.request(!this.newEmployee);
      }
    },
    clearTime1() {
      this.employee.startTime1 = null;
      this.employee.endTime1 = null;
    },
    clearTime2() {
      this.employee.startTime2 = null;
      this.employee.endTime2 = null;
    },
    clearTime3() {
      this.employee.startTime3 = null;
      this.employee.endTime3 = null;
    },
    checkTimeRegular() {
      // 1. 需要start1 和 end1 需要都要有, start2 and end2, start3 and end3
      // 2. 時間不得有重疊 start1~end1
      // if(this.startTime1 !== null && this.endTime1 !== null){
      //   if(this.startTime2 !== null) moment(this.startTime2).isBetween(this.startTime1, this.endTime1)
      // }
      // if(this.startTime2 !== null && this.endTime2 !== null){
      // }
      // if(this.startTime3 !== null && this.endTime3 !== null){
      // }
    },
    backToEmployeeInfo() {
      this.$router.go(-1);
    },
    validateRequired() {
      let notFilled = null;
      if (!this.newEmployee) {
        //若在編輯員工狀態，要排除驗證密碼欄位
        notFilled = Object.keys(this.required).find(item => {
          if (item === "payPassword") return false;
          return this.employee[item] === null;
        });
      } else {
        // 若在新增員工狀態，要驗證密碼欄位非空
        notFilled = Object.keys(this.required).find(
          item => this.employee[item] === null
        );
      }

      if (notFilled) {
        this.$Message.error(`請填入${this.required[notFilled]}`);
        return false;
      }
      return true;
    },
    request(isCurrentEmployee) {
      const formatedTime = this.formatAllHours();
      const url = `${isCurrentEmployee ? `/employee/${this.employee.jobNumber}` : "/employee"
        }`;
      if (isCurrentEmployee) {
        this.editEmplyee(formatedTime);
        return;
      }
      this.addEmplyee(formatedTime);
    },
    addEmplyee(formatedTime) {
      // 除去頭尾的空格
      console.log(this.employee);
      this.employee = {
        ...this.employee,
        department: this.employee.department && this.employee.department.trim(),
        division: this.employee.division && this.employee.division.trim(),
        email: this.employee.email && this.employee.email.trim(),
        factoryArea:
          this.employee.factoryArea && this.employee.factoryArea.trim(),
        jobNumber: this.employee.jobNumber && this.employee.jobNumber.trim(),
        name: this.employee.name && this.employee.name.trim(),
        phone: this.employee.phone && this.employee.phone.trim(),
        section: this.employee.section && this.employee.section.trim(),
        verificationCode:
          this.employee.verificationCode &&
          this.employee.verificationCode.trim()
      };
      console.log(this.employee);
      API.post("/employee", { ...this.employee, ...formatedTime })
        .then(res => {
          const { success: isSuccess } = res;
          if (isSuccess) {
            alert("新增員工成功");
            this.$router.push("employeelist");
            return;
          }
          this.$Message.error(res.result);
        })
        .catch(e => {
          this.$Message.error("網路異常，請再操作一次");
          console.error(e);
        });
    },
    editEmplyee(formatedTime) {
      // 除去頭尾的空格
      this.employee = {
        ...this.employee,
        department: this.employee.department && this.employee.department.trim(),
        division: this.employee.division && this.employee.division.trim(),
        email: this.employee.email && this.employee.email.trim(),
        factoryArea:
          this.employee.factoryArea && this.employee.factoryArea.trim(),
        jobNumber: this.employee.jobNumber && this.employee.jobNumber.trim(),
        name: this.employee.name && this.employee.name.trim(),
        phone: this.employee.phone && this.employee.phone.trim(),
        section: this.employee.section && this.employee.section.trim(),
        verificationCode:
          this.employee.verificationCode &&
          this.employee.verificationCode.trim()
      };
      // console.log(this.employee);
      // console.log(formatedTime);

      API.put(`/employee/${this.id}`, {
        ...this.employee,
        ...formatedTime
      })
        .then(res => {
          const { result, success: isSuccess } = res;
          if (isSuccess) {
            alert("更新員工成功");
            this.$router.push("employeelist");
          }
        })
        .catch(err => {
          this.$Message.error("網路異常，請再操作一次");
        });
    },
    formatAllHours() {
      // TODO: 需要去檢查時間是否有重複
      const toBeFormated = Object.keys(this.employee).filter(t =>
        t.includes("Time")
      );
      const formated = toBeFormated.reduce((result, key) => {
        if (Number(this.employee[key]) || this.employee[key] === 0) {
          result[key] = formatHour(this.employee[key]);
        }
        return result;
      }, {});
      return formated;
    },
    setData(data, id) {
      this.id = id;
      this.employee = { ...this.employee, ...data };
      if (this.employee.payLimit) {
        this.employee.isPayLimit = true;
      }
      if (this.employee.takingLimit) {
        this.employee.isTakingLimit = true;
      }
      this.showResponseTimeValueOnDropdow(data);
    },
    showResponseTimeValueOnDropdow(data) {
      //如果時段有值，就做字串切割，把 type 轉成 Number
      if (data.startTime1 && data.endTime1) {
        this.employee.startTime1 = Number(data.startTime1.split(":")[0]);
        this.employee.endTime1 = Number(data.endTime1.split(":")[0]);
      }
      if (data.startTime2 && data.endTime2) {
        this.employee.startTime2 = Number(data.startTime2.split(":")[0]);
        this.employee.endTime2 = Number(data.endTime2.split(":")[0]);
      }
      if (data.startTime3 && data.endTime3) {
        this.employee.startTime3 = Number(data.startTime3.split(":")[0]);
        this.employee.endTime3 = Number(data.endTime3.split(":")[0]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/components.scss";

.subtitle {
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 10px;

  &>span {
    color: red;
  }
}

.inputItemStyle {
  padding: 8px;
}

.inputTime {
  width: 100px;
}

.authorize-box {
  padding: 8px;
  display: flex;
  align-items: center;
}

.required::before {
  content: "* ";
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/EditEmployee.vue